import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./Call_Now_Modal.css";

function Call_Now_Modal({ show, handleClose, vendor }) {

    const displayData = vendor || {
        name: "Jay Hardware",
        location: "Katraj, Pune Maharashtra",
        material: "Hardware",
        image: "/assets/images/vendor1.png",
        verified: true
    };
    return (
        <Modal show={show} onHide={handleClose} centered className="call-now-modal">
            <Modal.Body className="p-0">
                <div className="modal-card-container">
                    <div className="modal-card-header">
                        <img
                            src={displayData.image}
                            alt={displayData.name}
                            className="img"
                        />
                    </div>
                    <div className="modal-card-content ">
                        <h5 className="vendor-name-modal mb-1">
                            {displayData.name}
                            <img
                                src="/assets/images/verified.png"
                                alt="verified"
                                className="verified-badge-img"
                            />
                        </h5>
                        <p className="vendor-location-modal mb-1">{displayData.location}</p>
                        <p className="vendor-material-modal">Material :- {displayData.material}</p>
                        <div className="phone-number-display-box my-3">
                            <span className="phone-number-text">+91 8965745896</span>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-1 pb-1">
                    <button className="modal-close-btn" onClick={handleClose}>
                        Close
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default Call_Now_Modal;